import { Injectable } from '@angular/core';
import {BehaviorSubject} from "rxjs";


export enum SchemaButton {
  PRIMARY = 'primary',
  RIGHT = 'right',
  LEFT = 'left',
  MIDDLE = 'middle'
}

@Injectable({
  providedIn: 'root'
})
export class HwwHelpService {
  public activeButton = new BehaviorSubject<SchemaButton>(SchemaButton.PRIMARY)
  public activeTertiaryButtons = []

  constructor() { }
}
